import { cx } from '@twind/core';

export default function PhoneIcon({ className }: { className?: string }) {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className={cx('ostro-phone-icon', '~(text-black)', className)}
      aria-label="Phone Icon"
    >
      <path
        d="M9.31597 12.1519C7.71353 11.4856 6.26039 10.5058 5.04193 9.26999C3.80616 8.05153 2.82635 6.5984 2.16005 4.99595C1.91048 4.37281 1.85019 3.68991 1.98672 3.03268C2.12326 2.37545 2.45056 1.77307 2.92768 1.3009L3.09032 1.13826C3.39225 0.836329 3.80176 0.666704 4.22876 0.666704C4.65576 0.666704 5.06527 0.836329 5.3672 1.13826L6.99355 2.76461C7.29548 3.06654 7.46511 3.47605 7.46511 3.90305C7.46511 4.33005 7.29548 4.73956 6.99355 5.04149L4.95086 7.08418L5.07934 7.24519C5.66665 7.97878 6.33315 8.64528 7.06673 9.23258L7.22774 9.36107L9.27043 7.31838C9.57237 7.01644 9.98187 6.84682 10.4089 6.84682C10.8359 6.84682 11.2454 7.01644 11.5473 7.31838L13.1737 8.94472C13.4756 9.24665 13.6452 9.65616 13.6452 10.0832C13.6452 10.5102 13.4756 10.9197 13.1737 11.2216L13.011 11.3842C12.5389 11.8614 11.9365 12.1887 11.2792 12.3252C10.622 12.4617 9.93911 12.4014 9.31597 12.1519ZM6.18037 3.90305L4.22876 1.95144L3.90349 2.2767C3.61686 2.55693 3.41936 2.91555 3.33574 3.30759C3.25213 3.69962 3.28613 4.10761 3.43348 4.4804C3.59925 4.88669 3.79045 5.28214 4.00595 5.66438L4.1572 5.92622L6.18037 3.90305ZM12.3605 10.0832L10.4089 8.13155L8.3857 10.1547L8.65079 10.3027C9.03307 10.5182 9.42851 10.7094 9.83477 10.8752C10.2069 11.0219 10.6139 11.0559 11.0052 10.9729C11.3965 10.8899 11.7547 10.6936 12.0352 10.4084L12.3605 10.0832Z"
        fill="currentColor"
      />
    </svg>
  );
}
